import React, { Component } from 'react';
import { Icon, Layout, Row, Col, Card } from 'antd';
import { Link } from 'react-router-dom';
import { find, propEq } from 'ramda';
import { withAsyncActions } from 'react-async-client';

import { getProjects } from 'actions/asyncActions';
import { project_edit } from 'constants/routes';
import BackButton from 'components/common/elements/BackButton';
import Date from 'components/common/fields/Date';
import Applications from '../Applications';
import Breakpoint from 'components/layout/Breakpoint.js';

@withAsyncActions({
    getProjects,
}, { dispatchOnMount: true })
export default class ProjectView extends Component {
    render() {
        const { id } = this.props.match.params;
        const { data } = this.props.getProjects;

        const project = find(propEq('id', Number(id)), data.projects || []);

        return !project ? '' : (
            <Layout className="project container page page-sm-no-m sm-720 md-970 main-content">
                <Row type="flex" align="middle" className="m-b-30 xs-p-20" justify="space-between">
                    <Row type="flex" align="middle">
                        <BackButton />
                        <Breakpoint min="sm">
                            <div className="title-route m-l-30">
                                 Проект: {project.name}
                            </div>
                        </Breakpoint>
                    </Row>
                    <Link className="title-link" to={project_edit.stringify({ id: project.id })}>
                        <Icon type="edit" />  Редактировать
                    </Link>
                </Row>
                <Breakpoint max="sm">
                    <div className="title-route xs-p-20">
                        Проект: {project.name}
                    </div>
                </Breakpoint>
                <Row gutter={30} className="xs-p-20 m-t-30">
                    <Col md={12} sm={24}>
                        <div className="project-title">Описание проекта</div>
                        <p className="project-description">
                            {project.description}
                        </p>
                    </Col>
                </Row>
                <div className="m-t-50 project-view-cards sm-720 xs-fullwidth">
                    <Card className="card-covered xs-fullwidth" title="Адрес:" cover={<Icon type="environment-o" />} bordered={false}>
                        <p className="card-content card-content-bold">
                            {project.region.name}, {project.locality_name},
                            дом {project.house_number}{project.housing_number ? ` ${project.housing_number}` : ''},
                            квартира {project.apartment_number}
                        </p>
                    </Card>
                    <Card className="card-covered xs-fullwidth" title="Тип проекта:" cover={<Icon type="profile" />} bordered={false}>
                        <p className="card-content card-content-bold">
                            {project.project_type}
                        </p>
                    </Card>
                    <Card className="card-covered xs-fullwidth" title={<span>Планируемый срок<br /> сдачи проекта:</span>} cover={<Icon type="calendar" />} bordered={false}>
                        <p className="card-content card-content-bold">
                            <Date date={project.finishing_date} />
                        </p>
                    </Card>
                </div>
                <div className="xs-p-20">
                    <Applications id={project.id} regionName={project.region.name} {...this.props} />
                </div>
            </Layout>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/projects/project/ProjectView.js